import { render, staticRenderFns } from "./DepositDividend.vue?vue&type=template&id=fe68f54c&scoped=true"
import script from "./DepositDividend.vue?vue&type=script&lang=js"
export * from "./DepositDividend.vue?vue&type=script&lang=js"
import style0 from "./DepositDividend.vue?vue&type=style&index=0&id=fe68f54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe68f54c",
  null
  
)

export default component.exports